import { useCallback } from "react";
import { useLocation } from "react-router-dom";

import { Box, Typography } from "@mui/material";

import { useAuthContext } from "@covertree/auth";
import {
  CreateNewPasswordForm,
  CreateNewPasswordFormData,
} from "@covertree/ui";

export default function CreateNewPassword() {
  const { state } = useLocation();

  const username = state.username;
  const isPasswordReset = state.isPasswordReset;

  const { createNewPassword, resendForgotPasswordCode, resetPassword } =
    useAuthContext();

  const submit = useCallback(
    async (form: CreateNewPasswordFormData) => {
      if (isPasswordReset) {
        await resetPassword(username!, form.code!, form.password);
      } else {
        await createNewPassword(form);
      }
    },
    [isPasswordReset, username, resetPassword, createNewPassword]
  );

  const secondaryAction = useCallback(async () => {
    await resendForgotPasswordCode(username!);
  }, [resendForgotPasswordCode, username]);

  return (
    <>
      <Typography sx={(theme) => ({ color: theme.palette.info.main })}>
        to{" "}
        <Typography
          component="span"
          sx={(theme) => ({
            fontWeight: "bold",
            color: theme.palette.text.primary,
          })}>
          {username}
        </Typography>
        {isPasswordReset && (
          <Box my={2}>
            <Typography>
              We have sent you an email with the code. Enter it below and create
              a new password.
            </Typography>
          </Box>
        )}
      </Typography>
      <CreateNewPasswordForm
        submit={submit}
        secondaryAction={secondaryAction}
        isPasswordReset={isPasswordReset}
      />
    </>
  );
}
